import { render, staticRenderFns } from "./SysDictDataEdit.vue?vue&type=template&id=6c38a5e0"
import script from "./SysDictDataEdit.vue?vue&type=script&lang=js"
export * from "./SysDictDataEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports